// extracted by mini-css-extract-plugin
module.exports = {"marketing-title":"marketing-title__marketing-title___vMnmF"};